import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Portrait } from "@bw/bits"
import { breakpoints } from "../../../theme"

const TeaserProfile = ({ name, role, portrait, to }) => {
  const profile = (
    <Wrapper className="profile">
      <Portrait image={portrait} />

      {(name || role) && (
        <Body>
          {name && <Name>{name}</Name>}
          {role && <Role>{role}</Role>}
        </Body>
      )}
    </Wrapper>
  )

  if (to) {
    return <StyledLink to={to}>{profile}</StyledLink>
  }

  return profile
}

const StyledLink = styled(Link)`
  display: block;
  color: var(--text-color);
  text-decoration: none;
  transition: opacity 0.4s;

  &:hover {
    opacity: 0.85;
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Body = styled.div`
  width: 100%;
  text-align: center;
  line-height: 1.2;
  font-size: 15px;

  @media (min-width: ${breakpoints.small}px) {
    font-size: 16px;
    max-width: 160px;
  }
`

const Name = styled.div`
  font-weight: 700;
`

const Role = styled.div`
  margin-top: 0.5em;
  font-size: 0.8em;
`

TeaserProfile.propTypes = {
  to: PropTypes.string,
  portrait: PropTypes.element,
  role: PropTypes.string,
  firstname: PropTypes.string,
  lastname: PropTypes.string,
}

export { TeaserProfile }
